<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
            v-if="data.form"
        >

            <rkm-area
                no-margin-top
                title="Filtros"
                type="fieldset"
            >
                <template slot="trailing">
                    <rkm-button
                        :title="filtroVisible ? 'Ocultar' : 'Exibir'"
                        @click="filtroVisible = !filtroVisible"
                        color="primary"
                        small
                    >
                        <rkm-icon :icon="`angle-double-${filtroVisible ? 'up' : 'down'}`" />
                    </rkm-button>
                </template>

                <component
                    :is="'rkm-collapse'"
                    :visible="filtroVisible"
                >

                    <rkm-row>

                        <rkm-col cols="6">
                            <rkm-form-date-picker
                                range
                                :range-inline="false"
                                start-label="Período de"
                                end-label="Até"
                                v-model="model.periodo"
                                :max-date="data.form.dataAtual"
                                :start-validations="validations.periodo.start"
                                :end-validations="validations.periodo.end"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-select
                                :options="agendamentoExame"
                                label="Exame / Grupo"
                                show-default-option
                                text-field="nome"
                                v-model="model.exameId"
                                value-field="id"
                                @change="setListagem()"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-select
                                :options="unidadeSolicitante"
                                label="Unidade solicitante"
                                show-default-option
                                text-field="nomeFantasia"
                                v-model="model.unidadeId"
                                value-field="unidadeId"
                                @change="setListagem()"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-select
                                label="Local de atendimento"
                                :options="infraestruturas"
                                textField="nome"
                                v-model="model.infraestruturaId"
                                valueField="id"
                                show-default-option
                                @change="setListagem()"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-select
                                :options="unidadeColeta"
                                label="Local de coleta"
                                show-default-option
                                text-field="nomeFantasia"
                                v-model="model.coletaUnidadeId"
                                value-field="unidadeId"
                                :validations="validations.coletaUnidade"
                                @change="setListagem()"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-select
                                label="Local de atendimento"
                                :options="coletaInfraestruturas"
                                textField="nome"
                                v-model="model.coletaInfraestruturaId"
                                valueField="id"
                                show-default-option
                                :validations="validations.coletaInfraestrutura"
                                @change="setListagem()"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row class="flex-nowrap">

                        <rkm-col cols="6" >
                            <rkm-form-input-autocomplete
                                :searchFields="localPaciente.autocompleteFieldsPaciente.paciente"
                                :repository="repositories.paciente"
                                v-model="paciente"
                                :text-field="(item) =>  item.cidadao.cns ? `${this.formatCns(item.cidadao.cns)} - ${item.cidadao.nome}` : item.cidadao.nome"
                                label="Paciente"
                                uppercase
                                @select="setListagem()"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                label="Prontuário"
                                v-model="model.prontuario"
                                number
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                label="Número do agendamento"
                                v-model="model.agendamentoNumero"
                                number
                            />
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-button
                                :label="false"
                                color="primary"
                                @click="$refs.Form.validate(search)"
                            >
                                Buscar
                            </rkm-button>

                            <rkm-button
                                :label="false"
                                @click="resetForm()"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </component>
            </rkm-area>
        </rkm-form>

        <rkm-row v-if="isSearch">

            <rkm-col
                cols="12"
            >
                <rkm-area
                    title="Status dos exames"
                    type="fieldset"
                >
                    <rkm-row>

                        <rkm-col
                            class="flex-grow-1"
                        >
                            <rkm-form-input
                                label="Agendado"
                                :disabled="true"
                                v-model="model.agendado"
                            />
                        </rkm-col>

                        <rkm-col
                            class="flex-grow-1"
                        >
                            <rkm-form-input
                                label="Realizado"
                                :disabled="true"
                                v-model="model.realizado"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                label="Duplicidade"
                                :disabled="true"
                                v-model="model.duplicidade"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                label="Outros"
                                :disabled="true"
                                v-model="model.outros"
                            />
                        </rkm-col>
                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                label="Faltou"
                                :disabled="true"
                                v-model="model.faltou"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-3" v-if="isSearch">
            <rkm-col>
                <rkm-button
                    @click="handleListPrint()"
                    color="primary"
                    class="mb-2"
                    :disabled="itemsNotSave && itemsNotSave.length == 0"
                >
                    Imprimir listagem
                </rkm-button>

                <template>
                    <rkm-button
                        @click="handleEtiquetaPrint()"
                        class="mb-2"
                        :disabled="itemsNotSave && itemsNotSave.length == 0"
                    >
                        Imprimir etiqueta(s)
                    </rkm-button>
                </template>

                <template>
                    <rkm-button
                        @click="handleStatus()"
                        color="info"
                        class="mb-2"
                        :disabled="itemsNotSave && itemsNotSave.length == 0"
                    >
                        Atribuir todos como realizado
                    </rkm-button>
                </template>
            </rkm-col>
        </rkm-row>

        <div
            v-for="(agendamento, index) in itemsNotSave"
            class="mb-3"
            :key="index"
        >

            <rkm-table
                :items="agendamento.exames"
                :fields="fields"
                hide-filters
                sort-by="data"
                :sort-compare="sortCompare"
                hide-pagination
                class="table-agendamento"
            >

                <template #thead-top>

                    <rkm-tr v-if="usuario.length <= 1">

                        <rkm-th class="table-width-60">

                            <div class="table-width-50 float-left">
                                Paciente: {{ agendamento.pacienteNome }}
                                <span v-if="agendamento.pacientePreferenciaNome">
                                    <strong>({{ agendamento.pacienteNomeSocial }})</strong>
                                </span>
                            </div>

                            <div>
                                Idade: {{ agendamento.pacienteIdade }}
                            </div>
                        </rkm-th>

                        <rkm-th class="table-width-30">
                            Data de nascimento: {{ agendamento.pacienteNascimento }}
                        </rkm-th>

                        <rkm-th class="col-min text-center">
                            Prontuário: {{ agendamento.pacienteProntuario }}
                        </rkm-th>
                    </rkm-tr>

                    <rkm-tr v-else>

                        <rkm-th class="table-width-30">
                            Paciente: {{ agendamento.pacienteNome }}
                            <span v-if="agendamento.pacientePreferenciaNome">
                                <strong>({{ agendamento.pacienteNomeSocial }})</strong>
                            </span>
                        </rkm-th>

                        <rkm-th>
                            Idade: {{ agendamento.pacienteIdade }}
                        </rkm-th>

                        <rkm-th>
                            Data de nascimento: {{ agendamento.pacienteNascimento }}
                        </rkm-th>

                        <rkm-th class="col-min text-center">
                            Prontuário: {{ agendamento.pacienteProntuario }}
                        </rkm-th>
                    </rkm-tr>

                    <rkm-tr v-if="usuario.length <= 1">

                        <rkm-th>

                            <div class="table-width-50 float-left">
                                Médico: {{ agendamento.medicoNome }}
                            </div>

                            <div>
                                Unidade solicitante: {{ agendamento.unidadeNome }}
                            </div>
                        </rkm-th>

                        <rkm-th>
                            Local de atendimento: {{ agendamento.infraestruturaNome }}
                        </rkm-th>

                        <rkm-th class="col-min text-center">
                            Agendamento: {{ agendamento.agendamentoNumero }}
                        </rkm-th>
                    </rkm-tr>

                    <rkm-tr v-else>

                        <rkm-th>
                            Médico: {{ agendamento.medicoNome }}
                        </rkm-th>

                        <rkm-th>
                            Unidade solicitante: {{ agendamento.unidadeNome }}
                        </rkm-th>

                        <rkm-th>
                            Local de atendimento: {{ agendamento.infraestruturaNome }}
                        </rkm-th>

                        <rkm-th class="col-min text-center">
                            Agendamento: {{ agendamento.agendamentoNumero }}
                        </rkm-th>
                    </rkm-tr>
                </template>

                <template v-slot:cell(usuarioId)="{ item }">
                    <rkm-form-select
                        :label="false"
                        :options="usuario"
                        textField="usuarioOcupacao"
                        v-model="item.usuarioId"
                        valueField="id"
                        show-default-option
                        class="pt-0 mb-0"
                        @change="handleOcupacao(item)"
                    />
                </template>

                <template v-slot:cell(status)="{ item }">
                    <rkm-form-select
                        :label="false"
                        :options="data.form.status"
                        textField="descricao"
                        v-model="item.statusId"
                        valueField="id"
                        show-default-option
                        class="pt-0 mb-0"
                    />
                </template>

                <template v-slot:cell(actions)="{ item }">

                    <rkm-button
                        small
                        title="Imprimir etiqueta"
                        @click="handlePrint(agendamento, item)"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        color="primary"
                        small
                        title="Detalhamento"
                        @click="$refs.Modal.open(agendamento, item)"
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>
                </template>
            </rkm-table>
        </div>

        <rkm-table
            v-if="itemsNotSave && itemsNotSave.length == 0 && isSearch"
            :items="itemsNotSave"
            :fields="fields"
            hide-filters
            sort-by="data"
        />

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase, printExameLaboratorial } from '@/mixins'

// Components.
import Modal from './Modal'

// Moment.
import moment from 'moment'

// Enums.
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    components: { Modal },
    computed: {
        fields() {
            const fields = [
                {
                    key: "exameGrupoNome",
                    label: "Exame / Grupo",
                    sortable: true
                },
            ]

            if (this.usuario.length > 1 ) {

                fields.push({
                    key: 'usuarioId',
                    label: 'Profissional - CBO',
                })
            }

            fields.push(
                {
                    key: 'status',
                    label: 'Status',
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min text-center'
                }
            )

            return fields
        },
        autocompletesRequestParams() {

            return {
                exame: {
                    queryString: {
                        tipo_id: this.tipoExameId,
                        exame_grupo: true,
                    }
                }
            }
        },
        fieldsAutoComplete() {

            return {
                autocompletes: {
                    exame: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true }
                    ],
                }
            }
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                coletaUnidade: { required: true },
                coletaInfraestrutura: { required: true },
            }
        },
        infraestruturas() {

            this.setInfraestrutura()

            if (this.model.unidadeId && this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId)) {

                let infraestruturaPrincipal = this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId).infraestruturas

                if (!this.model.unidadeDisabled) {

                    this.handleInfraestrutura(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
        usuario() {

            let usuario = []

            this.data.form.unidadesFaturamento.forEach(item => {

                if (item.infraestruturaId == this.model.coletaInfraestruturaId) {

                    usuario.push(item.usuario)
                }

                item.faturamentoRelacionado.forEach(relacionado => {

                    if (relacionado.relacionadaInfraestruturaId == this.model.coletaInfraestruturaId) {

                        usuario.push(item.usuario)
                    }
                })
            })

            if (usuario.length == 1) {

                this.handleUsuario(usuario)
            }

            return usuario
        },
        coletaInfraestruturas() {

            this.setColetaInfraestrutura()

            if (this.model.coletaUnidadeId && this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId)) {

                let infraestruturaPrincipal = this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId).infraestruturas

                if (!this.model.unidadeDisabled) {

                    this.handleColetaInfraestrutura(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.repositories = {
            lancamento: this.getConectaSusRepository('exameLaboratorial.lancamentoColeta'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            exame: this.getConectaSusRepository('parametrizacao.exame'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
        },

        this.load();
    },
    data() {
        return {
            model: {
                exame: null,
                exameId: null,
                exameNome: null,
                pacienteId: null,
                unidadeId: null,
                infraestruturaId: null,
                coletaUnidadeId: null,
                coletaInfraestruturaId: null,
                prontuario: null,
                agendamentoNumero: null,
                status: null,
                agendado: 0,
                realizado: 0,
                duplicidade: 0,
                outros: 0,
                faltou: 0,
                pertenceGrupo: null,
                mapaAgrupado: null,
                unidadeNome: null,
                infraestruturaNome: null,
                coletaUnidadeNome: null,
                coletaInfraestruturaNome: null,
                periodo: {
                    start: null,
                    end: null,
                },
            },
            filtroVisible: true,
            itemsNotSave: [],
            saveAgendamento: {
                agendamentos: [],
            },
            paciente: null,
            unidadeSolicitante: [],
            unidadeColeta: [],
            agendamentoExame: [],
            items: [],
            localPaciente: {
                autocompleteFieldsPaciente: {
                    paciente: [
                        { key: 'cidadao.nome', searchable: true },
                    ],
                },
            },
            enums: {
                statusAgendamento,
                preferenciaNome
            },
            unwatchers: {
                modelPeriodoEnd: null,
                modelPeriodoStart: null,
            },
            isSearch: false,
        }
    },
    mixins: [repository, error, object, formats, data, printExameLaboratorial, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'data') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        load() {

            this.model.agendado = this.data.form.agendado
            this.model.duplicidade = this.data.form.duplicidade
            this.model.faltou = this.data.form.faltou
            this.model.outros = this.data.form.outros
            this.model.realizado = this.data.form.realizado

            this.model.periodo = this.data.form.periodo

            this.$nextTick()
                .then(() => this.loadFields())
                .then(() => this.addWatchers())
        },
        save(){

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (!this.checkAgendamento()) {

                        this.showAlert('É obrigatório selecionar o especialista para cada agendamento realizado.')

                        return false
                    }

                    this.setLoading()

                    this.repositories.lancamento.store(this.prepareData())
                        .then(() => {

                            this.showSaveNotification()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading(this.$nextTick(() => this.resetForm())))
                })
        },
        prepareData() {

            if (this.itemsNotSave && this.itemsNotSave.length > 0) {

                this.saveAgendamento.agendamentos = this.clone(this.itemsNotSave)

                const notSave = this.saveAgendamento

                return this.camelObjectKeysToSnakeRecursive(notSave)
            } else {

                const model = this.clone(this.data.model)

                return this.camelObjectKeysToSnakeRecursive(model)
            }
        },
        checkAgendamento() {

            let check = true

            if (this.itemsNotSave && this.itemsNotSave.length > 0 && this.usuario.length > 1) {

                this.itemsNotSave.forEach(agendamento => {

                    if (agendamento.statusId == this.enums.statusAgendamento.REALIZADO &&
                        !agendamento.usuarioId) {

                            check = false
                        }
                })
            }

            return check
        },
        search() {

            this.setLoading()

            this.repositories.lancamento.list(this.getSearchParams())
                .then(({ data }) => {

                    this.itemsNotSave = data.model.agendamentos

                    this.model.agendado = data.form.agendado
                    this.model.duplicidade = data.form.duplicidade
                    this.model.faltou = data.form.faltou
                    this.model.outros = data.form.outros
                    this.model.realizado = data.form.realizado

                    this.isSearch = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            if (this.paciente) {

                params.pacienteId = this.paciente.id
                params.pacienteNome = this.paciente.cidadao.nome
            }

            if (this.model.exameId) {

                params.pertenceGrupo = this.agendamentoExame.find(u => u.id == this.model.exameId).pertenceGrupo
                params.mapaAgrupado = this.agendamentoExame.find(u => u.id == this.model.exameId).mapaAgrupado
                params.exameNome = this.agendamentoExame.find(u => u.id == this.model.exameId).nome
            }

            if (this.model.unidadeId) {

                if (this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId)) {

                    this.model.unidadeNome = this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId).nomeFantasia
                }
            }

            if (this.model.infraestruturaId) {

                if (this.infraestruturas.find(u => u.id == this.model.infraestruturaId)) {

                    this.model.infraestruturaNome = this.infraestruturas.find(u => u.id == this.model.infraestruturaId).nome
                }
            }

            if (this.model.coletaUnidadeId && this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId)) {

                this.model.coletaUnidadeNome = this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId).nomeFantasia
            }

            if (this.model.coletaInfraestruturaId) {

                if (this.coletaInfraestruturas.find(u => u.id == this.model.coletaInfraestruturaId)) {

                    this.model.coletaInfraestruturaNome = this.coletaInfraestruturas.find(u => u.id == this.model.coletaInfraestruturaId).nome
                }
            }

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.model.exame = null
            this.model.exameId = null
            this.paciente = null
            this.model.agendamentoNumero = null
            this.model.prontuario = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.itemsNotSave = []
            this.model.agendado = this.data.form.agendado
            this.model.duplicidade = this.data.form.duplicidade
            this.model.faltou = this.data.form.faltou
            this.model.outros = this.data.form.outros
            this.model.realizado = this.data.form.realizado
            this.isSearch = false

            this.setDefaultValues()

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        handleInfraestrutura(infraestruturaPrincipal) {

            if ( this.model.unidadeId == this.data.form.unidadeId && this.data.form.infraestruturaId) {

                this.model.infraestruturaId = this.data.form.infraestruturaId
            } else {

                if (infraestruturaPrincipal.find(u => u.principal === true)) {

                    this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
                } else {

                    this.model.infraestruturaId = null
                }
            }
        },
        handleColetaInfraestrutura(infraestruturaColetaPrincipal) {

            if ( this.model.coletaUnidadeId == this.data.form.unidadeId && this.data.form.infraestruturaId) {

                this.model.coletaInfraestruturaId = this.data.form.infraestruturaId
            } else {

                if (infraestruturaColetaPrincipal.find(u => u.principal === true)) {

                    this.model.coletaInfraestruturaId = infraestruturaColetaPrincipal.find(u => u.principal === true).id
                }
            }
        },
        setInfraestrutura() {

            if (this.data.form.infraestruturaId && this.model.unidadeId) {

                this.model.infraestruturaId = this.data.form.infraestruturaId
            } else {

                this.model.infraestruturaId = null
            }
        },
        setColetaInfraestrutura() {

            if (this.data.form.infraestruturaId && this.model.coletaUnidadeId) {

                this.model.coletaInfraestruturaId = this.data.form.infraestruturaId
            } else {

                this.model.coletaInfraestruturaId = null
            }
        },
        handleStatus() {

            if (this.itemsNotSave && this.itemsNotSave.length > 0) {

                this.showConfirmation(
                    'Todos os exames serão atribuídos como REALIZADO. Deseja continuar?',
                    async () => this.itemsNotSave.forEach(item => {
                        item.exames.forEach(exame => {
                            exame.statusId = this.enums.statusAgendamento.REALIZADO
                        })
                    })
                )
            }
        },
        handleListPrint() {

            this.setLoading()

            this.repositories.impressao.lancamentoColeta(this.getSearchParams())
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .finally(() => this.unsetLoading())
        },
        handleEtiquetaPrint() {

            if (this.itemsNotSave && this.itemsNotSave.length > 0) {

                this.print().etiquetaColeta(this.itemsNotSave, this.data.form.sistema, this.data.form.unidade)
            } else {

                this.print().etiquetaColeta(this.data.model.agendamentos, this.data.form.sistema, this.data.form.unidade)
            }
        },
        handlePrint(agendamento, item) {

            this.print().etiquetaColetaIndividual(agendamento, item, this.data.form.sistema, this.data.form.unidade)
        },
        loadFields() {

            this.setLoading()

            this.repositories.lancamento.loadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.loadUnidadeSolicitante(data.model.unidadesSolicitante)
                    this.loadUnidadeColeta(data.model.unidadesColeta)
                    this.loadExame(data.model.agendamentos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadUnidadeSolicitante(unidades) {

            this.unidadeSolicitante = unidades
            this.model.unidadeId = null

            const unidadeSolicitante = unidades.find(u => u.unidadeId == this.data.form.unidadeId);

            if (unidadeSolicitante) {

                const infraestruturaSolicitante = unidadeSolicitante.infraestruturas
                    .find(infraestrutura => infraestrutura.id == this.data.form.infraestruturaId)

                    if (infraestruturaSolicitante) {
                        this.model.unidadeId = this.data.form.unidadeId
                        this.model.infraestruturaId = this.data.form.infraestruturaId
                    }
            }
        },
        loadUnidadeColeta(unidades) {

            this.unidadeColeta = unidades
            this.model.coletaUnidadeId = null

            const unidadeColeta = unidades.find(u => u.unidadeId == this.data.form.unidadeId);

            if (unidadeColeta) {

                const infraestruturaCcoleta = unidadeColeta.infraestruturas
                    .find(infraestrutura => infraestrutura.id == this.data.form.infraestruturaId)

                    if (infraestruturaCcoleta) {
                        this.model.coletaUnidadeId = this.data.form.unidadeId
                        this.model.coletaInfraestruturaId = this.data.form.infraestruturaId
                    }
            }
        },
        loadExame(agendamento) {

            const exameCadastrado = []

           agendamento.map(exame => {

                const exameInserido = exameCadastrado.find(u => u.id
                    === exame.exameGrupoId && u.pertenceGrupo === exame.pertenceGrupo)

                if (!exameInserido) {

                    exameCadastrado.push({

                        id: exame.exameGrupoId,
                        nome: exame.exameGrupoNome,
                        pertenceGrupo: exame.pertenceGrupo,
                        mapaAgrupado: exame.mapaAgrupado,
                    })
                }
            })

            if (exameCadastrado) {

                exameCadastrado.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
            }

            this.agendamentoExame = exameCadastrado
        },
        handleOcupacao(item) {

            this.data.form.unidadesFaturamento.forEach(faturamento => {

               if (faturamento.usuario.id == item.usuarioId) {

                 item.ocupacaoId = faturamento.usuario.ocupacaoId
               }
            })
        },
        handleUsuario(usuarios) {

            usuarios.map(usuario => {

                if (this.itemsNotSave && this.itemsNotSave.length > 0) {

                    this.itemsNotSave.forEach(agendamento => {

                        agendamento.exames.forEach(exame => {

                            exame.usuarioId = usuario.id
                            exame.ocupacaoId = usuario.ocupacaoId
                        })
                    })
                } else {

                    this.data.model.agendamentos.forEach(agendamento => {

                        agendamento.usuarioId = usuario.id
                        agendamento.ocupacaoId = usuario.ocupacaoId
                    })
                }
            })
        },
        setListagem() {

            this.itemsNotSave = null
        },
        addWatchers() {

            this.addModelPeridoStartWatcher()
            this.addModelPeridoEndWatcher()
        },
        addModelPeridoStartWatcher() {

            this.unwatchers.modelPeriodoStart = this.$watch('model.periodo.start', function () {

                this.setListagem()

                if (this.model.periodo.start && this.model.periodo.end) {

                    this.loadFields()
                }

            })
        },
        addModelPeridoEndWatcher() {

            this.unwatchers.modelPeriodoEnd = this.$watch('model.periodo.end', function () {

                this.setListagem()

                if (this.model.periodo.start && this.model.periodo.end) {

                    this.loadFields()
                }

            })
        },
    },
    props: {
        data: { type: Object, required: true }
    },
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-width {
    width: 100%;
}
.table-width-60 {
    width:60%;
}
.table-width-50 {
    width:50%;
}
.table-width-30 {
    width:30%;
}
thead > tr {
 line-height: 15px;
}
</style>